module.exports = __webpack_public_path__ + "static/media/cattleya.93ba5946.png";